import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
}



// WEBPACK FOOTER //
// /Users/jessepinuelas/Development/jesse/freeground.io/src/app/app.component.ts